import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import MedicalHistory from './MedicalHistory';
import Vaccinations from './Vaccinations';
import Allergies from './Allergies';
import DietaryRestrictions from './DietaryRestrictions';
import Accomodations from './Accomodations';
import HealthInsuranceInformation from './HealthInsuranceInformation';
import PermissionSplash from 'components/PermissionSplash';

export default class Health extends React.Component {
	render() {
		let routeProps = this.props;
		const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
			return (role.section === 'Health' && role.access_read === "1")
		}) : false
	if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			return (
				<Switch>
					<Route path="/portal/health/Medical History Form" render={() => <MedicalHistory {...routeProps} />} />
					<Route path="/portal/health/Vaccinations" render={() => <Vaccinations {...routeProps} />} />
					<Route path="/portal/health/Allergies" render={() => <Allergies {...routeProps} />} />
					<Route path="/portal/health/Dietary Restrictions" render={() => <DietaryRestrictions {...routeProps} />} />
					<Route path="/portal/health/Special Accomodations" render={() => <Accomodations {...routeProps} />} />
					<Route path="/portal/health/Health Insurance Information" render={() => <HealthInsuranceInformation {...routeProps} />} />
					<Route path="*" render={() => (
						<Redirect to="/portal/health/Medical History Form" />
					)} />
				</Switch>
			);
		} else {
			return (

				<PermissionSplash />

			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Health/index.jsx